import clsx from 'clsx'
import { Input } from 'components/core-v2/atoms'
import Icon from 'components/core-v2/atoms/Icon'
import _ from 'lodash'
import { useCallback } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { ClassName } from 'types/props'

import classes from './search-field.module.scss'

export interface SearchFieldProps extends ClassName {
  debounceMs?: number
  id: string
  isDisabled?: boolean
  placeholder?: string
}

export const SearchField = ({
  className,
  debounceMs = 0,
  id,
  isDisabled = false,
  placeholder,
  ...props
}: SearchFieldProps) => {
  const { register, resetField } = useFormContext()
  const searchValue = useWatch({ name: id })

  const clearSearch = useCallback(() => resetField(id), [id, resetField])

  const formProps = register(id)
  const onChange = _.debounce(formProps.onChange, debounceMs)
  return (
    <div className={clsx(classes.root, className)}>
      <Icon className={classes.searchIcon} name="search" />
      <Input
        aria-label={placeholder}
        className={classes.input}
        id={id}
        isDisabled={isDisabled}
        placeholder={placeholder}
        type="search"
        {...formProps}
        {...props}
        onChange={onChange}
      />
      {searchValue && (
        <button className={classes.clearButton} type="button" onClick={clearSearch}>
          <Icon className={classes.clearIcon} name="remove" />
        </button>
      )}
    </div>
  )
}
